import React from 'react';
import styles from './Loading.css';

function Loading() {
  return (
    <div className={styles.loadingContainer}>
      <svg
        className={styles.imgg}
        width='264'
        height='196'
        viewBox='-50 -100 400 300'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M123.588 179.553L123.583 179.549C94.684 154.553 70.9527 133.999 54.41 114.695C37.8961 95.4248 28.9121 77.8092 28.9121 58.7466C28.9121 27.5998 54.476 3.10981 87.3938 3.10981C103.931 3.10981 119.842 14.6091 131.779 26.989C134.72 30.039 139.607 30.0282 142.552 27.0167C154.619 14.6743 171.591 3.10981 188.18 3.10981C221.098 3.10981 246.662 27.5998 246.662 58.7466C246.662 77.8092 237.678 95.4248 221.164 114.695C204.621 133.999 180.89 154.553 151.99 179.549L151.986 179.553C143.841 186.625 131.733 186.625 123.588 179.553Z'
          stroke='#CDAA64'
          strokeWidth='6.21961'
        />
        <path
          d='M5 124.571H73.7526C74.3174 124.571 74.8258 124.229 75.0379 123.705L89.6551 87.629C90.1285 86.4606 91.7891 86.4788 92.2368 87.6573L113.031 142.395C113.509 143.654 115.32 143.561 115.667 142.261L137.568 60.291C137.928 58.9416 139.832 58.9114 140.235 60.2486L165.076 142.632C165.454 143.887 167.201 143.965 167.69 142.749L189.705 88.0177C190.194 86.802 191.941 86.8801 192.319 88.1346L203.016 123.585C203.192 124.171 203.732 124.571 204.343 124.571H258.439'
          stroke='#CDAA64'
          strokeWidth='9.32942'
          strokeLinecap='round'
        />
      </svg>
      <span className={styles.brand}>
        MEDIFY<p className={styles.brandIn}>ME</p>
      </span>
    </div>
  );
}

export default Loading;
